import React from "react";

import { Button, Card, Col, Collapse, Row } from "antd";

import PageHeading from "../../../components/common/PageHeading";
import SubHeading from "../../../components/common/SubHeading";
import ApprovalFlow from "./ApprovalFlow";

import "./BillsApprovalFlow.css";
import RightBar from "../../../components/common/RightBar";
import Footer from "../../../components/common/Footer";

const { Panel } = Collapse;

function BillsApprovalFlow() {
  const onChange = (key) => {
    console.log(key);
  };

  const BillsApprovalFlowRightBar = [];

  return (
    <>
      <div className="page-container">
        <div className="bills-approval-flow main-container">
          <PageHeading heading="Bills Approval Flow" />
          <div className="flows-container">
            <Card title="Bills Approval Flow">
              <SubHeading subHeading="Default Bill Approval" />
              <div className="default-bill-approval">
                <ApprovalFlow />
                <ApprovalFlow />
              </div>
              <Row justify="center">
                <Col>
                  <Button type="link" size="large">
                    Add Dollar Range
                  </Button>
                </Col>
              </Row>
            </Card>
            <Card className="approval-flow" title="Approval Flow 1">
              <div className="accounts-container">
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Asset" key="1">
                    <p>Assets Content</p>
                  </Panel>
                </Collapse>
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Liability" key="2">
                    <p>Liability Content</p>
                  </Panel>
                </Collapse>
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Capital" key="3">
                    <p>Capital Content</p>
                  </Panel>
                </Collapse>
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Income" key="4">
                    <p>Income Content</p>
                  </Panel>
                </Collapse>
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Expense" key="5">
                    <p>Expense Content</p>
                  </Panel>
                </Collapse>
              </div>
              <ApprovalFlow />
              <Row justify="center">
                <Col>
                  <Button type="link" size="large">
                    Add Dollar Range
                  </Button>
                </Col>
              </Row>
              <div className="actions">
                <Button type="link" size="large">
                  Rename
                </Button>
                <Button type="link" size="large" danger>
                  Delete
                </Button>
              </div>
            </Card>
          </div>
          <Button className="add-gl-btn">+ Add GL Approval Flow</Button>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={BillsApprovalFlowRightBar}/>
      </div>
    </>
  );
}

export default BillsApprovalFlow;
